//@flow strict

import * as React from 'react';
import {useReleaseFlag} from 'src/hooks/product-flags';
import {useSelector} from 'react-redux';
import css from 'src/components/lib/messaging-input/url-highlight-message.css';


type Props = {
  children: React.Node,
};

const UrlHighlightMessage = ({children}: Props): React.Node => {
  const isLinkShorteningFlagEnabled = useReleaseFlag(
    'enableMessagingLinkShortening',
  );
  const shortenLinkSettingEnabled = useSelector(
    (state) => state.agentSettings.messagingEnableLinkShortening,
  );

  // Only render the highlighted URL if both conditions are met
  if (isLinkShorteningFlagEnabled && shortenLinkSettingEnabled) {
    return <span className={css.urlHighlight}>{children}</span>;
  }

  return <span>{children}</span>;
};

export default UrlHighlightMessage;
